import React, { useState, useEffect, setState } from 'react';
import {
  Platform,
  StatusBar,
  StyleSheet,
  Text,
  TextInput,
  View,
  TouchableOpacity,
  ImageBackground,
} from "react-native";

import { COLORS, SIZES, IMAGES, FONTS } from '../constants';
import { useNavigation } from '@react-navigation/native';
import { MaterialIcons } from '@expo/vector-icons';

import AsyncStorage from '@react-native-async-storage/async-storage';

import { RadioBtn, OutlineBtn, SolidBtn } from '../components'
import { Picker } from '@react-native-picker/picker';

export default function ProfileScreen() {

  const navigation = useNavigation();
  const [isLoading, setIsLoading] = useState(true);

  const [age, setAge] = useState(0);
  const [ageGroup, setAgeGroup] = useState("");
  const [sex, setSex] = useState("");
  const [category, setCategory] = useState("");
  const [selectedPosition, setSelectedPosition] = useState(0);
  const [profileInfo, setProfileInfo] = useState();

  const zapiszProfil = async (props) => {

    const profileToSave = {
      age: age,
      group: ageGroup,
      sex: sex,
      cat: category,
      column: selectedPosition
    }

    try {
      await AsyncStorage.setItem('@profile', JSON.stringify(profileToSave));
      setProfileInfo(profileToSave);

    } catch (err) {
      // saving error
      console.log(err)
    }
  }

  const getData = async () => {
    try {
      const jsonValue = await AsyncStorage.getItem('@profile')
      // console.log(JSON.parse(jsonValue))

      setProfileInfo(JSON.parse(jsonValue));
      setAge(JSON.parse(jsonValue).age);
      setAgeGroup(JSON.parse(jsonValue).group);
      setSex(JSON.parse(jsonValue).sex);
      setCategory(JSON.parse(jsonValue).cat);
      setSelectedPosition(JSON.parse(jsonValue).column);
    } catch (e) {
      console.log("error", e)
    }

    setIsLoading(false);
  }

  useEffect(() => {
    // AsyncStorage.clear();
    getData();
  }, []);

  const calculateAgeGroup = (props) => {
    // console.log("calculateAgeGroup")

    switch (true) {
      case (props == 0):
        setAgeGroup("Błąd")
        break;
      case (props < 18):
        setAgeGroup("Jesteś zbyt młody")
        break;
      case (props >= 18 && props <= 20):
        setAgeGroup("I")
        break;
      case (props >= 21 && props <= 25):
        setAgeGroup("II")
        break;
      case (props >= 26 && props <= 30):
        setAgeGroup("III")
        break;
      case (props >= 31 && props <= 35):
        setAgeGroup("IV")
        break;
      case (props >= 35 && props <= 40):
        setAgeGroup("V")
        break;
      case (props >= 41 && props <= 45):
        setAgeGroup("VI")
        break;
      case (props >= 45 && props <= 50):
        setAgeGroup("VII")
        break;
      case (props >= 51 && props <= 55):
        setAgeGroup("VIII")
        break;
      case (props >= 56):
        setAgeGroup("IX")
        break;
      default:
        setAgeGroup("Błąd")
        break;
    }
  }

  if (isLoading) {
    return (
      <ImageBackground
        source={IMAGES.bg2}
        style={styles.bg}
      >
        <View style={styles.container}>
          <Text style={styles.titleText}>Pobieram dane...</Text>
        </View>
      </ImageBackground>
    );
  }

  return (

    <ImageBackground
      source={IMAGES.bg2}
      style={styles.bg}
    >

      <View style={styles.container}>
        <View style={styles.header}>
          <View style={styles.headerLeft}>
            <Text style={styles.subtitleText}> uzupełnij poniższe dane</Text>
          </View>

          <View style={styles.headerRight}>
            {(ageGroup === "Błąd") ? (
              <View style={styles.outlineBtn}>

                <Text style={styles.outlineBtnText}>
                  Nieprawidłowy wiek
                </Text>
              </View>

            ) : ((ageGroup === "Jesteś zbyt młody") ? (
              <View style={styles.outlineBtn}>

                <Text style={styles.outlineBtnText}>
                  {ageGroup}
                </Text>
              </View>
            ) : ((ageGroup === "0") ? (
              null
            ) : (
              <View style={styles.outlineBtn}>

                <Text style={styles.outlineBtnText}>
                  Grupa wiekowa {ageGroup}
                </Text>
              </View>
            )
            )
            )}
          </View>
        </View>


        <View style={styles.formRow}>
          <Text style={styles.label}>Wiek</Text>
          <View style={styles.input}>

            <TextInput
              value={age !== 0 ? age : ""}
              maxLength={2}
              style={styles.inputBox}
              placeholder="Ile masz lat? /np. 47/"
              placeholderTextColor={COLORS.secondary}
              keyboardType="numeric"
              onChangeText={text => {
                calculateAgeGroup(text);
                setAge(text);
              }}
            />
          </View>
        </View>
        <View style={styles.formRow}>
          <Text style={styles.label}>Płeć</Text>
          <View style={styles.input}>
            <RadioBtn
              selected={sex === "K" ? true : false}
              changeValue={() => {
                setSex("K");
                // zapiszProfil();
              }}
              text="K"
            />
            <RadioBtn
              selected={sex === "M" ? true : false}
              changeValue={() => {
                setSex("M");
                // zapiszProfil();
              }}
              text="M"
            />
          </View>
        </View>

        <View style={styles.formRow}>
          <Text style={styles.label}>Kategoria</Text>
          <View style={styles.input}>
            <RadioBtn
              selected={category === "Z" ? true : false}
              changeValue={() => {
                setCategory("Z");
                setSelectedPosition(1);
              }}
              text="Z"
            />
            <RadioBtn
              selected={category === "Z/O" ? true : false}
              changeValue={() => {
                setCategory("Z/O");
                setSelectedPosition(5);
              }}
              text="Z/O"
            />
          </View>
        </View>

        <View style={styles.formRow}>
          <Text style={styles.label}>Stanowisko</Text>
          <View style={styles.input}>
            <Picker
              style={styles.positionPicker}
              selectedValue={selectedPosition}
              onValueChange={(itemValue, itemIndex) =>
                setSelectedPosition(itemValue)
              }>
              {category === "Z/O" ? null : <Picker.Item label="Kolumna 1" value="1" />}
              {category === "Z/O" ? null : <Picker.Item label="Kolumna 2" value="2" />}
              {category === "Z/O" ? null : <Picker.Item label="Kolumna 3" value="3" />}
              {category === "Z/O" ? null : <Picker.Item label="Kolumna 4" value="4" />}
              {category === "Z/O" ? <Picker.Item label="Kolumna 5" value="5" /> : null}
            </Picker>

          </View>
          <View style={styles.info}>
            <TouchableOpacity
              onPress={() => navigation.navigate('Groups')}
            >
              <MaterialIcons name="info-outline" size={24} color={COLORS.accent} />

            </TouchableOpacity>

          </View>
        </View>

        <OutlineBtn
          text="Moje konkurencje"
          onPress={() => navigation.navigate('Disciplines')}
        />

        <SolidBtn
          text="Zapisz"
          onPress={() => {
            zapiszProfil();
            navigation.goBack();
          }}
        />
      </View>
    </ImageBackground>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: Platform.OS === "ios" ? 40 : StatusBar.currentHeight + 10,
    flex: 1,
    padding: SIZES.padding,
  },
  header: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignContent: 'space-around',
    alignItems: 'flex-start',
  },
  headerLeft: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    // width: '60%',
    paddingTop: 0
  },
  headerRight: {
    alignItems: 'center',
    justifyContent: 'center',
    height: 30,
    paddingTop: 0
  },
  titleText: {
    ...FONTS.title
  },
  subtitleText: {
    ...FONTS.subtitle
  },
  outlineBtn: {
    backgroundColor: COLORS.background,
    borderColor: COLORS.secondary,
    borderRadius: 5,
    borderWidth: 1,
    alignItems: 'center',
    justifyContent: 'center',
    width: 130,
    height: 30,
  },
  outlineBtnText: {
    color: COLORS.primary,
    fontSize: 12
  },
  bg: {
    width: '100%',
    height: '100%'
  },
  formRow: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    alignItems: 'center',
    alignContent: 'center',
    height: 50,
    margin: 10
  },
  label: {
    width: 90,
    color: COLORS.primary,
    alignItems: 'center',

    fontSize: 16,
  },
  input: {
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
    marginLeft: 15,
  },
  info: {
    width: 50,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center'
  },
  inputBox: {
    borderColor: COLORS.primary,
    backgroundColor: COLORS.background,
    borderWidth: 1,
    borderRadius: 10,
    textAlign: "center",
    alignSelf: 'stretch',
    // width: 200,
    height: 50,
    fontSize: 15,
    color: COLORS.accent
  },
  positionPicker: {
    borderColor: COLORS.primary,
    backgroundColor: COLORS.background,
    borderWidth: 1,
    borderRadius: 10,
    alignItems: 'center',
    textAlign: 'center',
    alignSelf: 'stretch',
    // width: 160,
    paddingHorizontal: 30,
    height: 50,
    fontSize: 16,
    color: COLORS.accent
  },

});